import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m9 15 11-8 11 8v18H9z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M20 21h-7v12h7z"
    />
    <path
      fill="#00215B"
      d="M22 31h-1v-8h-6v-1h7zM6.59 15.81 6 15l11-8 4 3-.6.8-3.41-2.56z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnWoning);

export default ForwardRef;
